import { useState } from "react";

import { UpdateIconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, pn } from "@compass/core";

import { ListBeProperty } from "components";
import { Permission, PermissionAction, SortObject, SurveyListDto, SurveyListResource } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";

import { surveyPageRoute } from "../SurveyPage/SurveyPage";

export const SurveyTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  surveys: SurveyListDto[];
  resource: SurveyListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell type="id">
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<SurveyListDto>("id"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<SurveyListDto>("name"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<SurveyListDto>("questionCount"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.surveys.map((survey) => (
            <TableRow
              key={survey.id}
              onClick={() => navigate(surveyPageRoute.getPath({ id: survey.id, crudMode: "view" }))}
            >
              <TableCell type="id">{survey.id}</TableCell>
              <TableCell>{survey.name}</TableCell>
              <TableCell>{survey.questionCount}</TableCell>
              <TableCell type="action">
                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton
                    onClick={() => navigate(surveyPageRoute.getPath({ id: survey.id, crudMode: "edit" }))}
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
